import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted mt-2" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_7 = { class: "dropdown ml-2" }
const _hoisted_8 = {
  class: "btn btn-link",
  style: {"font-size":"2em","padding":"0"},
  "data-toggle": "dropdown"
}
const _hoisted_9 = {
  class: "dropdown-menu dropdown-menu-scrollable",
  role: "menu"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = { class: "dropdown-menu" }
const _hoisted_14 = { class: "dropdown-item" }
const _hoisted_15 = { class: "dropdown-item" }
const _hoisted_16 = { class: "dropdown-item" }
const _hoisted_17 = { style: {"text-transform":"lowercase"} }
const _hoisted_18 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_19 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_20 = {
  class: "btn-group mr-2",
  role: "group"
}
const _hoisted_21 = { class: "btn-group" }
const _hoisted_22 = {
  class: "btn btn-outline-secondary",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_23 = { class: "dropdown-menu dropdown-menu-scrollable" }
const _hoisted_24 = { class: "btn-group" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "dropdown-menu dropdown-menu-scrollable" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 0,
  class: "dropdown-header"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "btn-group" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "dropdown-menu dropdown-menu-scrollable" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  class: "form-inline my-2 my-lg-0 ml-auto",
  role: "search"
}
const _hoisted_36 = { class: "btn-group" }
const _hoisted_37 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_38 = {
  class: "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
  role: "menu"
}
const _hoisted_39 = {
  key: 0,
  class: "dropdown-header"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "mt-3",
  style: {"height":"calc(100% - 60px)"}
}
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-lg-12" }
const _hoisted_44 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_45 = { style: {"display":"inline-block","height":"100%"} }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onDragenter", "onDragleave", "onDrop"]
const _hoisted_48 = { style: {"transform":"rotate(90deg)"} }
const _hoisted_49 = {
  key: 1,
  class: "card mr-1",
  style: {"width":"19vw","min-width":"300px","height":"100%"}
}
const _hoisted_50 = { class: "card-header" }
const _hoisted_51 = { class: "dropdown float-right" }
const _hoisted_52 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onDragenter", "onDragleave", "onDrop"]
const _hoisted_58 = ["onDragstart"]
const _hoisted_59 = { class: "float-right" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { style: {"white-space":"normal"} }
const _hoisted_62 = ["onUpdate:modelValue"]
const _hoisted_63 = { class: "font-italic mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlternativeEditorDialog = _resolveComponent("AlternativeEditorDialog")!
  const _component_AlternativesComparisonDialog = _resolveComponent("AlternativesComparisonDialog")!
  const _component_ViewSettingsEditor = _resolveComponent("ViewSettingsEditor")!
  const _component_ListSelectionDialog = _resolveComponent("ListSelectionDialog")!
  const _component_NumericInputDialog = _resolveComponent("NumericInputDialog")!
  const _component_MonthPickerDialog = _resolveComponent("MonthPickerDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_AlternativeEditorDialog, { viewModel: _ctx.alternativeEditorDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativesComparisonDialog, { viewModel: _ctx.alternativesComparisonDialog }, null, 8 /* PROPS */, ["viewModel"]),
    (_ctx.viewSettingsEditor)
      ? (_openBlock(), _createBlock(_component_ViewSettingsEditor, {
          key: 0,
          viewModel: _ctx.viewSettingsEditor,
          onSaved: _ctx.onViewSettingsUpdated
        }, null, 8 /* PROPS */, ["viewModel", "onSaved"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_ListSelectionDialog, {
      viewModel: _ctx.statusListSelectionDialog,
      onUpdateValue: _ctx.handleUpdateMultipleAlternativesStatusCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_ListSelectionDialog, {
      viewModel: _ctx.attrListSelectionDialog,
      onUpdateValue: _ctx.handleMultipleAlternativesAttributeValueUpdateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_NumericInputDialog, {
      viewModel: _ctx.numericInputDialog,
      onUpdateValue: _ctx.handleMultipleAlternativesAttributeValueUpdateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_MonthPickerDialog, {
      viewModel: _ctx.startDateMonthPicker,
      onUpdateDate: _ctx.handleUpdateMultipleAlternativesStartDateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateDate"]),
    _createVNode(_component_MonthPickerDialog, {
      viewModel: _ctx.commitmentDateMonthPicker,
      onUpdateDate: _ctx.handleUpdateMultipleAlternativesCommitmentDateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateDate"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.rm.TchProjectName), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.rm.AlternativesLabel) + ":", 1 /* TEXT */),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.viewDefName) + " ", 1 /* TEXT */),
                    _cache[21] || (_cache[21] = _createElementVNode("i", {
                      class: "fa fa-caret-down",
                      style: {"font-size":"0.7em","vertical-align":"middle"}
                    }, null, -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setViewDef()))
                    }, "All"),
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                    _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "dropdown-header" }, "Custom lists", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Views, (v) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "dropdown-item",
                        key: v.Id,
                        onClick: ($event: any) => (_ctx.setViewDef(v.Id))
                      }, _toDisplayString(v.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[28] || (_cache[28] = _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary dropdown-toggle mr-1",
                  style: {"padding":"0.7em 2em"},
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false"
                }, " Actions ", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("Import", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, _ctx.url_ImportAlternativesPage]
                  ]),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleExportAlternativesCommand && _ctx.handleExportAlternativesCommand(...args)))
                  }, "Export"),
                  _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_15, [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("Edit statuses", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, _ctx.url_ManageKanbanPage]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("Edit labels", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, _ctx.url_ManageLabelsPage]
                  ])
                ])
              ]),
              _createElementVNode("button", {
                role: "button",
                class: "btn btn-success mr-1",
                style: {"padding":"0.7em 2em"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showAlternativeCreator && _ctx.showAlternativeCreator(...args)))
              }, [
                _cache[29] || (_cache[29] = _createTextVNode(" Create ", -1 /* CACHED */)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.rm.AlternativeLabel), 1 /* TEXT */)
              ]),
              _cache[30] || (_cache[30] = _createElementVNode("a", {
                class: "btn btn-lg btn-outline-secondary",
                href: "https://www.transparentchoice.com/user-guide/pipeline",
                title: "User guide: Configure pipeline",
                target: "_blank"
              }, [
                _createElementVNode("i", {
                  class: "fa fa-info",
                  "aria-hidden": "true"
                })
              ], -1 /* CACHED */))
            ])
          ]),
          _cache[46] || (_cache[46] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 20px"} }, null, -1 /* CACHED */)),
          _createElementVNode("nav", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showViewSettingsEditor && _ctx.showViewSettingsEditor(...args)))
              }, [...(_cache[31] || (_cache[31] = [
                _createElementVNode("i", {
                  class: "fa fa-cog",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.collapseAllColumns && _ctx.collapseAllColumns(...args))),
                title: "Collapse all columns"
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1 /* CACHED */)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.expandAllColumns && _ctx.expandAllColumns(...args))),
                title: "Expand all columns"
              }, [...(_cache[33] || (_cache[33] = [
                _createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1 /* CACHED */)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", _hoisted_22, [
                  _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa-regular fa-square-check" }, null, -1 /* CACHED */)),
                  _createTextVNode(" (" + _toDisplayString(_ctx.selectedAlternatives?.length) + ") ", 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectAll()))
                  }, "Select all"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.unselectAll()))
                  }, "Unselect all"),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.invertSelection()))
                  }, "Invert selection")
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                  disabled: !_ctx.selectedAlternatives?.length
                }, [...(_cache[35] || (_cache[35] = [
                  _createElementVNode("i", {
                    class: "fa fa-pencil",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Edit ", -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_25),
                _createElementVNode("div", _hoisted_26, [
                  _cache[36] || (_cache[36] = _createElementVNode("h6", { class: "dropdown-header" }, "Edit selected", -1 /* CACHED */)),
                  (_ctx.selectedAlternatives?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showBulkStatusEditor && _ctx.showBulkStatusEditor(...args)))
                        }, "Status"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bulkEditablelistAttributesBySection, (items, section) => {
                          return (_openBlock(), _createElementBlock("div", { key: section }, [
                            section
                              ? (_openBlock(), _createElementBlock("h6", _hoisted_28, _toDisplayString(section), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (attr) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: attr.Id,
                                class: "dropdown-item",
                                onClick: ($event: any) => (_ctx.showBulkAttributeValueEditor(attr))
                              }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_29))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                  _createElementVNode("a", {
                    class: "dropdown-item",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteAlternativesCommand && _ctx.handleDeleteAlternativesCommand(...args)))
                  }, "Delete")
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                  disabled: !_ctx.selectedAlternatives?.length
                }, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("i", {
                    class: "fa-regular fa-calendar",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Dates ", -1 /* CACHED */)
                ]))], 8 /* PROPS */, _hoisted_31),
                _createElementVNode("div", _hoisted_32, [
                  _cache[39] || (_cache[39] = _createElementVNode("h6", { class: "dropdown-header" }, "Edit selected", -1 /* CACHED */)),
                  (_ctx.selectedAlternatives?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showBulkStartDateMonthPicker && _ctx.showBulkStartDateMonthPicker(...args)))
                        }, "Start date"),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showBulkCommitmentDateMonthPicker && _ctx.showBulkCommitmentDateMonthPicker(...args)))
                        }, "Commitment date")
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showSelectedAlternativesComparison && _ctx.showSelectedAlternativesComparison(...args))),
                disabled: !_ctx.selectedAlternatives?.length
              }, [...(_cache[40] || (_cache[40] = [
                _createElementVNode("i", {
                  class: "fa fa-balance-scale",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(" Compare ", -1 /* CACHED */)
              ]))], 8 /* PROPS */, _hoisted_34)
            ]),
            _createElementVNode("form", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchPhrase) = $event)),
                class: "form-control mr-sm-2",
                type: "search",
                placeholder: "Search",
                "aria-label": "Search"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.searchPhrase]
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", _hoisted_37, _toDisplayString(_ctx.orderByLabel), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_38, [
                _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "dropdown-header" }, "Order by:", -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setOrderBy('name')))
                }, "Name"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setOrderBy('modified')))
                }, "Date modified"),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setOrderBy('create date')))
                }, "Date created"),
                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesBySection, (items, section) => {
                  return (_openBlock(), _createElementBlock("div", { key: section }, [
                    section
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_39, _toDisplayString(section), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (attr) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: attr.Id,
                        class: "dropdown-item",
                        onClick: ($event: any) => (_ctx.setOrderBy(attr.Id.toString()))
                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_40))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", {
                    onDragover: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onDragOverContainer && _ctx.onDragOverContainer(...args))),
                    style: {"overflow-x":"auto","overflow-y":"hidden","height":"100%","width":"100%","white-space":"nowrap"}
                  }, [
                    (_ctx.columns)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.columns, (column) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (column.IsCollapsed === true)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "card pointer mr-1",
                                  onClick: ($event: any) => (column.IsCollapsed = false),
                                  style: {"width":"50px","height":"100%"}
                                }, [
                                  _cache[43] || (_cache[43] = _createElementVNode("div", { class: "card-header" }, [
                                    _createElementVNode("i", { class: "fa fa-angle-right" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", {
                                    onDragover: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"])),
                                    onDragenter: ($event: any) => (_ctx.onDragEnter($event, column)),
                                    onDragleave: ($event: any) => (_ctx.onDragLeave($event, column)),
                                    onDrop: ($event: any) => (_ctx.onDrop($event, column)),
                                    class: _normalizeClass([{ 'drag-over': column.dragOver }, "card-body bg-light"]),
                                    style: {"overflow-x":"hidden","overflow-y":"auto"}
                                  }, [
                                    _createElementVNode("h5", _hoisted_48, _toDisplayString(column.title), 1 /* TEXT */)
                                  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_47)
                                ], 8 /* PROPS */, _hoisted_46))
                              : _createCommentVNode("v-if", true),
                            (column.IsCollapsed === false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _cache[44] || (_cache[44] = _createElementVNode("a", {
                                        "data-toggle": "dropdown",
                                        class: "text-dark"
                                      }, [
                                        _createElementVNode("i", { class: "fa fa-ellipsis-h" })
                                      ], -1 /* CACHED */)),
                                      _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (column.selectAll())
                                        }, "Select all", 8 /* PROPS */, _hoisted_53),
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (column.invertSelection())
                                        }, "Invert selection", 8 /* PROPS */, _hoisted_54),
                                        _createElementVNode("a", {
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (column.unselectAll())
                                        }, "Unselect all", 8 /* PROPS */, _hoisted_55)
                                      ])
                                    ]),
                                    _createElementVNode("div", {
                                      class: "pointer",
                                      onClick: ($event: any) => (column.IsCollapsed = true)
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(column.title), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_56)
                                  ]),
                                  _createElementVNode("div", {
                                    onDragover: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["prevent"])),
                                    onDragenter: ($event: any) => (_ctx.onDragEnter($event, column)),
                                    onDragleave: ($event: any) => (_ctx.onDragLeave($event, column)),
                                    onDrop: ($event: any) => (_ctx.onDrop($event, column)),
                                    class: _normalizeClass([{ 'drag-over': column.dragOver }, "card-body"]),
                                    style: {"overflow-x":"hidden","overflow-y":"auto"}
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.alternativesView, (a) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: a.Id,
                                        draggable: true,
                                        onDragstart: ($event: any) => (_ctx.onDragStart($event, a))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["tile1", _ctx.getColorCssClass(a.Id)])
                                        }, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("a", {
                                              onClick: ($event: any) => (_ctx.showAlternativeEditor(a.Id))
                                            }, [...(_cache[45] || (_cache[45] = [
                                              _createElementVNode("i", { class: "fa fa-pencil" }, null, -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_60)
                                          ]),
                                          _createElementVNode("p", _hoisted_61, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": ($event: any) => ((a.IsSelected) = $event),
                                              type: "checkbox",
                                              class: "mr-1"
                                            }, null, 8 /* PROPS */, _hoisted_62), [
                                              [_vModelCheckbox, a.IsSelected]
                                            ]),
                                            _withDirectives((_openBlock(), _createElementBlock("a", null, [
                                              _createTextVNode(_toDisplayString(a.Name), 1 /* TEXT */)
                                            ])), [
                                              [_directive_sanitizedHref, _ctx.url_AlternativeDashboardPage(a.Id)]
                                            ])
                                          ]),
                                          _createElementVNode("h6", _hoisted_63, [
                                            _createElementVNode("small", null, _toDisplayString(_ctx.getColorLabel(a.Id)), 1 /* TEXT */)
                                          ])
                                        ], 2 /* CLASS */)
                                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_58))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_57)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 32 /* NEED_HYDRATION */)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}